import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';

import styles from './WeekPicker.scss';


// static propTypes = {
//   day: PropTypes.object.isRequired,
// };

const DatePicker = ({ day, ...props }) => (
  <span className={styles.main} {...props}>
    <Link to={`/children/${day.clone().subtract(1, 'week').format('YYYY-MM-DD')}`}>
      <span className={classNames(styles.icon, styles.iconLeft)}>&#10094;</span>
    </Link>
    <span className={styles.date}>
      {`${day.clone().weekday(0).format('DD.MM')} — ${day.clone().weekday(6).format('DD.MM')}`}
    </span>

    <Link to={`/children/${day.clone().add(1, 'week').format('YYYY-MM-DD')}`}>
      <span className={classNames(styles.icon, styles.iconRight)}>&#10095;</span>
    </Link>
  </span>
);

export default DatePicker;
